import { Component, OnInit, Input } from '@angular/core';
import { environment as params } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-seguro-left',
  templateUrl: './card-seguro-left.component.html',
  styleUrls: ['./card-seguro-left.component.scss']
})
export class CardSeguroLeftComponent implements OnInit {
  public urlBaseS3: any = (<any>params).api.s3;
  @Input('data') public data: any;
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }
  redirectTo(url: string) {
    this.router.navigate([url]);
  }
}
